/* Sis You're Crowned For This
   Puts The Word next to Prayer wall in the header, and into the mobile drawer.

   The header is a web component: its markup lives inside a <template> and is
   cloned into an open shadow root at load. That is why editing the Shopify
   menus does nothing to it. This adds the Bible links to the real header the
   moment it hydrates, and stays quiet if the header ever changes shape. */
(function () {
  var DRAWER =
    '<span class="grp">The Word</span>' +
    '<a href="/pages/bible">Read the Bible</a>' +
    '<a href="/pages/bible#syc-plans">Reading plans</a>' +
    '<a href="/pages/bible#syc-yours">Your Word</a>';

  function place() {
    var host = document.querySelector('syc-block[data-t="syc-t-header"]');
    if (!host || !host.shadowRoot) return false;
    var r = host.shadowRoot;
    if (r.querySelector('[data-syc-word]')) return true;

    var right = r.querySelector('.nav .right');
    if (!right) return false;

    var a = document.createElement('a');
    a.href = '/pages/bible';
    a.className = 'hide-m';
    a.setAttribute('data-syc-word', '');
    a.textContent = 'The Word';
    if (location.pathname.indexOf('/pages/bible') === 0) a.className = 'hide-m on';
    right.insertBefore(a, right.firstChild);

    var drawer = r.querySelector('.drawer');
    var firstGroup = drawer && drawer.querySelector('.grp');
    if (firstGroup) {
      var wrap = document.createElement('div');
      wrap.setAttribute('data-syc-word', '');
      wrap.style.display = 'contents';
      wrap.innerHTML = DRAWER;
      firstGroup.parentNode.insertBefore(wrap, firstGroup);
    }
    return true;
  }

  if (place()) return;
  var tries = 0;
  var t = setInterval(function () {
    if (place() || ++tries > 80) clearInterval(t);
  }, 100);
})();